import { call, put, takeLatest } from "@redux-saga/core/effects";
import { primeHoldingApis } from "./primeHoldingApis";
import { primeHoldingParsers } from "./primeHoldingParsers";
import { primeHoldingConstants } from "./primeHoldingConstants";

function* primeHoldingSaga(payload) {
    try {
        yield put({ type: primeHoldingConstants.PRIME_HOLDING_REQUEST });
        const res = yield call(primeHoldingApis.getPrimeHoldingList, payload.payload);
        const data = primeHoldingParsers.primeHoldingParser(res);
        yield put({ type: primeHoldingConstants.PRIME_HOLDING_RESPONSE, payload: data });

    } catch (error) {
        yield put({ type: primeHoldingConstants.PRIME_HOLDING_RESPONSE });
    }
}

export function* registerprimeHoldingSaga() {
    yield takeLatest(primeHoldingConstants.PRIME_HOLDING_SAGA, primeHoldingSaga);
}